<template>
  <v-expansion-panels
    v-model="openExpansion"
    :multiple="!isExpand"
    flat
    accordion
  >
    <v-expansion-panel
      v-for="(item, i) in nameGroups"
      :class="
        $vuetify.breakpoint.mdAndUp && !$route.query.embed
          ? 'mt-4 group-box'
          : ''
      "
      :key="i"
    >
      <v-expansion-panel-header
        :disabled="!item.open"
        :hide-actions="!item.open"
        :style="
          !$vuetify.breakpoint.mdAndUp || $route.query.embed
            ? 'border-top: 1px solid #dfdfdf; height: 90px'
            : 'height: 85px'
        "
      >
        <v-row no-gutters>
          <v-col>
            <v-row align="center" no-gutters>
              <span
                class="checkout-h6 accent--text title-group pr-2"
                style="font-weight: 450 !important"
                >{{ item.grupo }}</span
              >
              <v-spacer></v-spacer>
              <v-chip v-if="!item.open" outlined color="#838D9B">{{
                $t("cart.closed")
              }}</v-chip>
              <v-chip
                v-if="totalByProduct(item)"
                color="primary"
                class="pa-0 ma-0 mr-4 circle-quantity"
              >
                <span class="white--text">{{ totalByProduct(item) }}</span>
              </v-chip>
            </v-row>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="expansion-content">
        <ExpandedProducts
          v-if="isExpand"
          :noSectorList="noSectorList ? filterProducts(noSectorList, item) : []"
          :eventDetails="eventDetails"
          :group="true"
        ></ExpandedProducts>
        <div v-else>
          <div
            v-for="(product, index) in noSectorList
              ? filterProducts(noSectorList, item)
              : []"
            :key="index"
          >
            <NoExpandedProducts
              v-for="(type, i) in product"
              :key="i"
              :type="type"
              :eventDetails="eventDetails"
            ></NoExpandedProducts>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import NoExpandedProducts from "./NoExpandedProducts.vue";
import ExpandedProducts from "./ExpandedProducts.vue";
export default {
  props: ["noSectorList", "eventDetails", "isExpand"],
  data() {
    return {
      openExpansion: [],
    };
  },
  mounted() {
    if (!this.isExpand) this.openExpansion = this.nameGroups.map((g, i) => i);
  },
  computed: {
    formatedProducts() {
      let array = [];
      if (this.noSectorList) {
        this.noSectorList.forEach((p) => {
          p.forEach((t) => {
            array.push(t);
          });
        });
      }
      return array;
    },
    nameGroups() {
      let array = [];
      if (this.noSectorList) {
        this.noSectorList.forEach((p) => {
          if (
            array.find((a) => {
              return p[0].nome_grupo === a.grupo;
            })
          ) {
            array.push({ grupo: p[0].nome_grupo, show: false });
          } else {
            array.push({ grupo: p[0].nome_grupo, show: true });
          }
        });
      }
      let mappedArray = array.map((a) => {
        return {
          ...a,
          open: !!this.formatedProducts
            .filter((p) => {
              return a.grupo === p.nome_grupo;
            })
            .find((p) => {
              if (p.encerrado) return false;
              if (!p.encerrado) return true;
            }),
        };
      });
      return mappedArray.filter((g) => g.grupo && g.show);
    },
  },
  methods: {
    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;
      productTypes.forEach((type) => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }
          if (max < value) {
            max = value;
          }
        }
      });
      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return "";
      }
      min = this.$options.filters.currency(min);
      max = this.$options.filters.currency(max);
      return min !== max ? `A partir de ${min}` : min;
    },
    filterProducts(products, group) {
      if (products) {
        return products.filter(
          (i) => i[0].nome_grupo && i[0].nome_grupo === group.grupo
        );
      } else return [];
    },
    totalByProduct(group) {
      if (this.noSectorList) {
        let total = 0;
        this.noSectorList.forEach((product) => {
          total += product.reduce((total, element) => {
            return element.nome_grupo === group.grupo
              ? element.quantidade + total
              : 0 + total;
          }, 0);
        });
        return total;
      }
      return 0;
    },
  },
  components: { NoExpandedProducts, ExpandedProducts },
};
</script>

<style>
.v-expansion-panel-header--active .row .col .row .title-group {
  color: #f68d00 !important;
}
</style>

<style scoped>
.circle-quantity {
  width: 28px;
  height: 28px;
  border-radius: 20;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.group-box {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  border-radius: 10px;
  padding-bottom: 3px;
  padding-top: 3px;
}
</style>
